import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateEmploymentTypePayload,
  EmploymentTypeDto,
  UpdateEmploymentTypePayload,
} from '@/types/employmentType';
import type { ListFilterPayload } from '@/types/filters';

// ============================================
// Query Params
// ============================================

interface GetEmploymentTypesParams {
  page?: number;
  size?: number;
  sort?: string;
}

// ============================================
// Employment Types CRUD
// ============================================

export const getEmploymentTypes = async (
  params: GetEmploymentTypesParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<EmploymentTypeDto>> => {
  const response = await api.post<PaginatedResponse<EmploymentTypeDto>>(
    '/platform-service/v1/employment-types/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const createEmploymentType = async (
  data: CreateEmploymentTypePayload,
): Promise<EmploymentTypeDto> => {
  const response = await api.post<EmploymentTypeDto>(
    '/platform-service/v1/employment-types',
    data,
    { successToast: true },
  );
  return response.data;
};

export const updateEmploymentType = async (
  id: string,
  data: UpdateEmploymentTypePayload,
): Promise<EmploymentTypeDto> => {
  const response = await api.put<EmploymentTypeDto>(
    `/platform-service/v1/employment-types/${id}`,
    data,
    { successToast: true },
  );
  return response.data;
};

export const deleteEmploymentType = async (id: string): Promise<void> => {
  await api.delete(`/platform-service/v1/employment-types/${id}`, { successToast: true });
};
